import React, { FC, ReactNode } from 'react'
import { Row } from 'react-bootstrap'

interface PageBodyProps {
  children: ReactNode
}

const PageBodyComponent: FC<PageBodyProps> = ({ children }) => {
  return (
    <Row className="text-secondary">
      <div className="app-max-width">{children}</div>
    </Row>
  )
}
export default PageBodyComponent
